export default [

     {
          path: '/site-type',
          name: 'SiteType',
          component: () => import("@/views/Page/SiteType/SiteType.vue"),
           meta: {
               title: '#Default# | SiteType',
          },
     }
];